<script>
export default {
  name: "HomeQualification",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    months: {
      // [{ label, value, qualified }]
      type: Array,
      default: () => []
    },
    qualified: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    maxValue() {
      return Math.max(1, ...this.months.map(m => m.value));
    }
  },
  methods: {
    barHeight(value) {
      return Math.max(6, Math.round((value / this.maxValue) * 100)) + "%";
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <template v-if="loading">
        <div class="skeleton-block skeleton-pill mb-2" style="width: 130px; height: 22px;"></div>
        <div class="d-flex align-items-end qualification-bars">
          <div v-for="n in 3" :key="n" class="flex-fill d-flex flex-column align-items-center qualification-bar-col">
            <div class="qualification-medal"></div>
            <span class="skeleton-block" style="width: 24px; height: 13px;"></span>
            <div class="qualification-bar-track">
              <div class="skeleton-block" style="width: 100%; height: 10px;"></div>
            </div>
            <span class="skeleton-block" style="width: 36px; height: 13px;"></span>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="badge-pill mb-2" :class="qualified ? 'badge-pill-success' : 'badge-pill-danger'">
          {{ qualified ? 'Qualificado' : 'Não qualificado' }}
        </div>
        <div class="d-flex align-items-end qualification-bars">
          <div v-for="(month, index) of months" :key="index" class="flex-fill d-flex flex-column align-items-center qualification-bar-col">
            <div class="qualification-medal">
              <i v-if="month.qualified" class="bx bxs-medal text-success font-size-18"></i>
            </div>
            <span class="font-size-13 font-weight-bold notranslate" :class="month.qualified ? 'text-dark' : 'text-muted'">{{ month.value | points }}</span>
            <div class="qualification-bar-track">
              <div class="qualification-bar-fill" :class="month.qualified ? 'qualification-bar-fill-success' : ''" style="height: 10px;"></div>
            </div>
            <span class="font-size-13" :class="month.qualified ? 'text-dark font-weight-bold' : 'text-muted font-weight-semibold'">{{ month.label }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.qualification-bars {
  gap: 16px;
}

.qualification-bar-col {
  gap: 8px;
}

.qualification-medal {
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qualification-bar-track {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.qualification-bar-fill {
  width: 100%;
  border-radius: 999px;
  background: #d1d5db;
}

.qualification-bar-fill-success {
  background: #059669;
}

.badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
}

.badge-pill::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.badge-pill-success {
  background-color: #ecfdf5;
  color: #065f46;
}

.badge-pill-warning {
  background-color: #fffbeb;
  color: #92400e;
}

.badge-pill-danger {
  background-color: #fef2f2;
  color: #991b1b;
}

.skeleton-block {
  display: inline-block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eef0f2 25%, #e2e4e7 37%, #eef0f2 63%);
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;
}

.skeleton-pill {
  border-radius: 999px;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
